<template>
  <div>
    <!--正在微信登录中........................
     <br><span>code:{{ code }}</span>
    <br><span>state：{{ state }}</span>
    <br><span>url：{{ url }}</span>
    <br><span>token:{{ token }}</span>
    <br><span>info:{{ info }}</span> -->
  </div>
</template>

<script>
import { getUrlKey } from '@/utils/base'
import { Toast } from 'vant'
// const Base64 = require('js-base64').Base64
export default {
  components: {
    [Toast.name]: Toast
  },
  data() {
    return {
      code: undefined,
      state: undefined,
      url: undefined,
      token: undefined,
      info: undefined,
      toast1: undefined
    }
  },
  destroyed: function() {
    this.toast1.clear()
  },
  created() {
    this.toast1 = Toast.loading({
      mask: true,
      message: '加载中...'
    })
    this.code = getUrlKey('code')
    this.state = getUrlKey('state')
    this.url = getUrlKey('url')
    this.$store.dispatch('user/wechatLogin', {
      code: this.code,
      state: this.state,
      url: this.url
    })
  }
}
</script>

